// extracted by mini-css-extract-plugin
export var currencyInput = "_li-1";
export var currencySymbol = "_li-0";